export var ReactNativeFile = function ReactNativeFile(_ref) {
  var uri = _ref.uri,
      name = _ref.name,
      type = _ref.type;
  this.uri = uri;
  this.name = name;
  this.type = type;
};
_c = ReactNativeFile;

var _c;

$RefreshReg$(_c, "ReactNativeFile");